import { takeLatest, put, call } from 'redux-saga/effects';
import get from 'lodash/get';
import { sha256 } from 'js-sha256';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import { createAccount } from 'yoda-interfaces/lib/Account/AccountApi';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import setUserName from 'yoda-account-components/lib/common/setUserName';
import * as SignInActionTypes from '../actionTypes/SigninActionTypes';
import * as CreateAccountActionTypes from '../actionTypes/CreateAccountActionTypes';
import * as SignInSliderActionTypes from '../actionTypes/SignInSliderActionTypes';
import getBBid from '../helpers/Utils/bbid';

export function* createAccountSaga(action) {
    if (TokenProvider.get('ACCOUNT_ID')) {
        action.payload.guestAccountId = TokenProvider.get('ACCOUNT_ID');
    }
    delete action.payload.featureFlags;
    if (action.payload.keepMeLoggedIn) {
        const customHeaders = getBBid(__SERVER__, action.payload.keepMeLoggedIn);
        action.payload.customHeaders = customHeaders;
    }
    delete action.payload.keepMeLoggedIn;
    const response = yield call(createAccount, action.payload);
    const payload = {
        response: response.data,
    };

    payload.done = true;
    if (response.status === 200 || response.status === 201) {
        const userEmail = get(action, 'payload.emailAddress', '');
        TokenProvider.set('DP_USER_EMAIL', userEmail);
        TokenProvider.set('DP_USER_EMAIL_HASHED', sha256(userEmail));
        response.userState = '1';
        TokenProvider.storeTokens(response, 'header', true);

        setUserName('DP_USER_NAME');
        setUserName('DP_USER_INFO');
        setUserName('USER_ACCT_ID');
        setUserName('DYN_USER_ID');
        payload.isSuccess = true;
        if (TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD')) {
            const data = JSON.parse(TokenProvider.get('DP_SAVED_ITEMS_PAYLOAD'));
            yield put({
                type: SignInActionTypes.SAVED_ITEMS_MERGE,
                data,
                isSignInSliderReq: action.payload.isSignInSliderReq,
                payloadData: payload,
                source: 'createaccount',
            });
            LocalStorage.removeData('DP_SAVED_ITEMS_PAYLOAD');
        } else if (action.payload.isSignInSliderReq) {
            yield put({
                type: SignInSliderActionTypes.SIGNIN_SLIDER_CREATE_ACCOUNT_SUCCESS,
                payload,
            });
        } else {
            yield put({ type: CreateAccountActionTypes.CREATE_ACCOUNT_SUCCESS, payload });
        }
        // SIGN IN SLIDER
    } else {
        payload.isSuccess = false;
        if (action.payload.isSignInSliderReq) {
            yield put({
                type: SignInSliderActionTypes.SIGNIN_SLIDER_CREATE_ACCOUNT_ERROR,
                payload,
            });
        } else {
            yield put({
                type: CreateAccountActionTypes.CREATE_ACCOUNT_ERROR,
                payload,
            });
        }
    }
}

function* watchCreateAccountSaga() {
    yield takeLatest(CreateAccountActionTypes.CREATE_ACCOUNT, createAccountSaga);
}
watchCreateAccountSaga.sagaName = 'createAccountSaga';
export default watchCreateAccountSaga;
